import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";

const useStyles = makeStyles(theme => ({
  listitem: {
    paddingLeft: "40px",
    paddingRight: "40px",
    paddingTop: "16px",
    paddingBottom: "16px",
    color: "#757575"
  },
  list: {
    width: "240px"
  }
}));

export default function LinkDrawer(props) {
  const classes = useStyles();

  const elements = props.links
    ? props.links.map(l => (
        <ListItem
          button
          onClick={() => (window.location = l.href)}
          key={l.text}
          className={classes.listitem}
        >
          <ListItemText primary={l.text} />
        </ListItem>
      ))
    : [];

  return (
    <Drawer open={props.open} onClose={props.onClose}>
      <List className={classes.list}> {elements} </List>
    </Drawer>
  );
}
